import { css } from '@emotion/css';
import { TFunction } from 'i18next';
import React, { useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { RootState } from '../../features';
import { actions, MyDesignUploadErrorType } from '../../features/myDesign';
import { throttle } from '../../lib/utils';
import { ConfirmButton } from '../shared/buttons/ConfirmButton';
import { Dialog } from '../shared/dialog/Dialog';

export const MyDesignErrorDialog: React.FC = () => {
  const { t } = useTranslation(['my_design', 'translation']);
  const history = useHistory();
  const dispatch = useDispatch();
  const uploadErrorType = useSelector((state: RootState) => state.myDesign.uploadErrorType);
  useEffect(() => {
    return () => {
      dispatch(actions.clearError());
    };
  }, [dispatch]);

  const handleCloseClick = useCallback(
    throttle(() => {
      history.goBack();
    }, 1000),
    [history]
  );
  const text = getText(t, uploadErrorType);
  return (
    <Dialog title={t('translation:dialog_error')}>
      <>
        <p
          className={css`
            flex: 1 1 auto;
            display: flex;
            align-items: center;
            padding: 12px 0 32px;
          `}
        >
          {text}
        </p>
        <div
          className={css`
            flex: 0 0 auto;
            padding: 0 0 8px;
          `}
        >
          <ConfirmButton onClick={handleCloseClick}>
            {t('translation:dialog_button_ok')}
          </ConfirmButton>
        </div>
      </>
    </Dialog>
  );
};

// helper function
function getText(t: TFunction, errorType?: MyDesignUploadErrorType) {
  switch (errorType) {
    case 'unstable-network':
      return t('translation:error_unstable_network');
    case 'unknown':
    default:
      return t('error_upload_failed');
  }
}
